import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { TPage, TPageDto } from '../model/types'
import { setJwtToken } from '@/helpers/setRequestHeaders'

export const pagesApi = createApi({
    reducerPath: 'pagesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT,
        prepareHeaders: setJwtToken
    }),
    tagTypes: ['PAGES'],
    endpoints: builder => ({
        getAllPages: builder.query<TPage[], void>({
            query: () => ({ url: `/pages` }),
            providesTags: () => ['PAGES']
        }),
        createPage: builder.mutation<TPage, TPageDto>({
            query: data => ({ url: `/pages`, method: `POST`, body: data }),
            invalidatesTags: () => ['PAGES']
        }),
        updatePage: builder.mutation<TPage, Partial<TPageDto & { id: number }>>({
            query: data => {
                let id = data.id
                if (data.id) {
                    delete data.id
                }
                if (data.url) {
                    delete data.url
                }
                return { url: `/pages/${id}`, method: `PATCH`, body: data }
            },
            invalidatesTags: () => ['PAGES']
        }),
        deletePage: builder.mutation<void, { id: number }>({
            query: data => ({ url: `/pages/${data.id}`, method: `DELETE` }),
            invalidatesTags: ()=>["PAGES"]
        })
    })
})

export const { useGetAllPagesQuery, useCreatePageMutation, useUpdatePageMutation, useDeletePageMutation } = pagesApi
